import api from "../../../config/api";
import { call, put, takeLatest } from "redux-saga/effects";
import { retriveUserRequestAction, retriveUserSuccessAction, retriveUserFailureAction } from "../slice/userList";
const fetchUserData = async payload => {
  const USER_API_URL = `/adminportal/user`;
  const response = await api.get(USER_API_URL, {
    transformRequest: [(data, headers) => {
      headers["authorization"] = `Bearer ${payload}`;
      return data;
    }]
  });
  return response;
};
function* getUserDataSaga(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchUserData, payload);
    yield put(retriveUserSuccessAction(response.data));
  } catch (error) {
    yield put(retriveUserFailureAction(error));
  }
}
export function* watchRetriveUserData() {
  yield takeLatest(retriveUserRequestAction, getUserDataSaga);
}